export default class Notification  {

    constructor(message, options){

        let {
            type = 'warning',
            where = '#notifications-wrapper'
        } = options;


        this.msg = message;
        this.options = {
            type : type,
            where : where
        };
        this.wrapName = 'client-notifications';
        this.create();
    }

    create(){
        let w = document.getElementById(this.wrapName);
        if(w == null) {
            w = this.createWrapper();
        } else {
            w.classList.remove("hidden");
        }
        let par = document.createElement("p");
        let msg = document.createTextNode(this.msg);
        par.appendChild(msg);
        w.appendChild(par);
        document.querySelector(this.options.where).appendChild(w);
    }

    createWrapper(){
        let w = document.createElement("div");
        w.classList.add("alert");
        w.classList.add('alert-'+this.options.type);
        w.setAttribute("id", this.wrapName);
        return w;
    }



}


// WEBPACK FOOTER //
// ./src/js/inc/notification.js